import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Bell } from "@phosphor-icons/react";

export function NotificationsBell() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({ items: [], unread: 0 });
  const boxRef = useRef(null);
  const nav = useNavigate();

  const load = async () => { try { const r = await api.get("/pm/notifications"); setData(r.data); } catch (e) { /* ignore */ } };
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, []);
  useEffect(() => {
    const h = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h); return () => document.removeEventListener("mousedown", h);
  }, []);

  const toggle = async () => { const nx = !open; setOpen(nx); if (nx && data.unread) { await api.post("/pm/notifications/read"); setData((d) => ({ ...d, unread: 0 })); } };
  const go = (n) => { setOpen(false); nav("/tareas"); };

  return (
    <div className="relative shrink-0" ref={boxRef}>
      <button onClick={toggle} data-testid="notif-bell" className="relative p-2 rounded-md hover:bg-neutral-100 transition-colors">
        <Bell size={19} weight={data.unread ? "fill" : "regular"} className={data.unread ? "text-primary" : "text-neutral-600"} />
        {data.unread > 0 && <span data-testid="notif-badge" className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center">{data.unread > 9 ? "9+" : data.unread}</span>}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-80 bg-card border border-border rounded-md shadow-xl z-50 max-h-[70vh] overflow-y-auto" data-testid="notif-panel">
          <div className="px-3 py-2 border-b border-border text-sm font-semibold">Notificaciones</div>
          {data.items.length === 0 && <div className="px-3 py-6 text-sm text-muted-foreground text-center">Sin notificaciones</div>}
          {data.items.map((n) => (
            <button key={n.id} onClick={() => go(n)} data-testid={`notif-item-${n.id}`} className={`w-full text-left px-3 py-2.5 border-b border-border/50 last:border-0 hover:bg-muted transition-colors ${!n.read ? "bg-orange-50/40" : ""}`}>
              <p className="text-sm text-foreground">{n.text}</p>
              <p className="text-[11px] text-muted-foreground mt-0.5">{n.created_at ? new Date(n.created_at).toLocaleString("es-MX", { dateStyle: "medium", timeStyle: "short" }) : ""}</p>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
